


















import Vue from 'vue'
export default Vue.extend({
  props: {
    value: {
      type: Boolean,
    },
    variable: {
      type: String,
    },
    description: {
      type: String,
    },
  },
})
